export default __webpack_public_path__ + "static/media/LauraMacDonald.ac6d4db7.jpg";